<template>
  <header :style="{'background': background}">
    <div class="header">
      <div class="content">
        <div class="logo">
          <router-link to="/" @click="$router.push('/')">
            <span class="icon">EXQUISITE SHOWERS LIMITED</span>
          </router-link>
        </div>
        <div :class="['menu', {'exhibit': isOpenMenu}]">
          <div :class="[isOpenMenu? 'colse': 'open']" @click="isOpenMenu = !isOpenMenu" />
          <div :class="['menu_item', {'menu_item_focus': $route.path === item.path}]" v-for="(item, index) in menu" :key="index">
            <router-link :to="item.path">{{ item.value }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isOpenMenu: false,
      background: '#FBF9F9',
    };
  },
  methods: {
    handleExternalLink(externalUrl) {
      window.location.href = externalUrl;
      // 阻止vue-router的默认行为
      return false;
    },
  },
  watch: {
    '$route.path': function (newVal) {
      this.isOpenMenu = false;
    },
  },
  computed: {
    menu() {
      return [
        { name: 'Home', value: this.$t('home'), path: '/' },
        { name: 'Lending License', value: 'Lending License', path: '/License' },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin pixel-ratio() {
  @media screen and (-webkit-min-device-pixel-ratio: 1),
  screen and (min--moz-device-pixel-ratio: 1) {
    @import '../assets/scss/sprite/header.scss';
    .menu {
      .colse {
        @include sprite($close);
      }
      .open {
        @include sprite($menu);
      }
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 2),
  screen and (min--moz-device-pixel-ratio: 2) {
    @import '../assets/scss/sprite/header@2x.scss';
    .menu {
      .colse {
        @include sprite($close-2x);
      }
      .open {
        @include sprite($menu-2x);
      }
    }
  }
}
header {
  @include pixel-ratio();
  border-bottom: 1px solid #F6F6F6;
  transition: all 0.3s;
  /**
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    // background-color: #e6dcf3;
  }**/
  .content {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    height: 82px;
    text-align: center;
    .logo {
      display: inline-block;
      font-size: 18px;
      flex: 1;
      text-align: left;
      .icon {
        display: inline-block;
        background-repeat: no-repeat;
        // width: 50px;
        height: 50px;
        line-height: 50px;
        font-weight: 700;
        font-size: 20px;
        vertical-align: middle;
        padding: 16px 0 0 10px;
      }
      a {
        text-decoration: none;
        color: #433760;
      }
    }
    .menu {
      display: flex;
      .colse, .open {
        display: none;
        position: absolute;
        right: 25px;
        top: 21px;
      }
      .menu_item {
        text-align: center;
        flex: 1;
        margin: 0 20px;
        white-space: nowrap;
        border-top: 2px solid transparent;
        line-height: 82px;
        a {
          display: block;
          text-decoration: none;
          color: #333333;
          cursor: pointer;
          font-weight: 500;
          font-size: 20px;
          &:hover {
            color: #FDD65A;
          }
        }
        &_focus {
          border-top: 2px solid #FDD65A;
          a {
            color: #FDD65A;
          }
        }
      }
    }
  }
}
</style>
